<app-scripts-init></app-scripts-init>
<router-outlet></router-outlet>
<app-alerts></app-alerts>
